<template>
  <v-form ref="form">

    <p class="text-h6 font-weight-regular">Thông tin thanh toán</p>
      <div class="bill__field  py-1 d-flex justify-space-between">
        <div class=""> Tổng Tiền:</div>
        <div class="font-weight-bold">{{sum | formatMoney}}</div>
      </div>

      <div class="bill__field py-2 d-flex justify-space-between">
          <currency-input dense v-model="discount" label="Giảm giá"></currency-input>
      </div>

      <div class="bill__field py-1 d-flex justify-space-between">
        <div class="">Học viên Cần Trả:</div>
        <div class="font-weight-bold">{{total | formatMoney}}</div>
      </div>

      <div class="bill__field py-1 d-flex justify-space-between">
          <currency-input dense v-model="paid" label="Học viên thanh toán"></currency-input>
      </div>

      <div class="bill__field py-1 d-flex justify-space-between">
        <div class="">Học viên Nợ:</div>
        <div class="font-weight-bold">{{liabilities | formatMoney}}</div>
      </div>
    <autocomplete-student
      v-model="student"
      :defaultStudent="student"
      placeholder="Tìm kiếm học sinh"
      outlined
      dense
      return-object
      @change="selectStudent"
    />
    <date-picker :date.sync="date" filled label="Ngày" placeholder="Nhập Ngày" dense></date-picker>
    <v-textarea outlined no-resize placeholder="Ghi chú" v-model="notes" dense :height="45"></v-textarea>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'
import utils from '@/plugins/utils.js'
import _ from 'lodash'
export default {
  components: { CurrencyInput, AutocompleteStudent, DatePicker },
  props: {
    lead: Object,
    products: Array
  },
  data () {
    return {
      date: new Date().toISOString(),
      discount: '0',
      customerPaid: '0',
      notes: '',
      student: {},
      customerName: '',
      customerPhone: '',
      paymentType: 'cash',
      loading: false
    }
  },
  created () {
    this.reset()
  },
  computed: {
    ...mapState('constant', ['leadStatus', 'paymentTypes']),
    sum () {
      return this.products.reduce(
        (acc, cur) => (acc += cur.price * cur.quantity),
        0
      )
    },
    total () {
      return this.sum - parseInt(this.discount)
    },
    liabilities () {
      return this.total - parseInt(this.customerPaid)
    }
  },
  methods: {
    selectStudent (student) {
      this.student = student
      this.customerName = student.name
      this.customerPhone = student.phone
    },
    getValues () {
      return {
        id: this.lead.id,
        notes: this.notes,
        status: this.liabilities > 0 ? 'liabilities' : 'paid',
        liabilities: this.liabilities,
        total: this.total,
        items: this.products,
        discount: parseInt(this.discount),
        sum: parseInt(this.sum),
        student: _.get(this.student, 'id'),
        state: _.get(this.student, 'id') ? 'approved' : 'under-approval',
        contact: _.get(this.contact, 'id'),
        customerName: this.customerName,
        customerPhone: this.customerPhone,
        date: this.date
      }
    },
    reset () {
      this.customerName = this.lead.customerName
      this.customerPhone = this.lead.customerPhone
      this.notes = this.lead.notes
      this.discount = this.lead.discount
      this.student = this.lead.student || {}
      this.staff = this.lead.staff
      this.contact = this.lead.contact
      this.customerPaid = this.lead.customerPaid
      this.date = this.lead.date
    }
  },
  filters: {
    formatMoney (amount) {
      return utils.formatMoney(amount)
    }
  },
  watch: {
    lead (lead) {
      this.reset()
    }
  }
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
}
td {
  padding-left: 0 !important;
}
</style>
